<script>
  import { onMount } from "svelte"
  import CertTitle from "./certTitle.svelte"
  import CertData from "./certData.svelte"

  export let certArray = []
  export let activeSigner = ""
  export let isCNMismatch = false

  let data = {}

  let active = "subject"

  let certActive

  let toggleSwitch = false

  onMount(() => {
    certActive = certArray.length - 1
  })

  $: onCertChange(certActive)

  const onCertChange = (certActive) => {
    if (isNaN(certActive)) return
    data = certArray[certActive]

    if (data && active === "extension" && !Object.keys(data?.extension || {}).length) {
      active = "subject"
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div on:click|self class="fixed inset-0 z-50 !mt-0 flex select-none items-start justify-center overflow-y-auto bg-[#000000cc] p-6 backdrop-blur-md">
  <div class="flex h-[80vh] w-full select-none flex-col gap-6 rounded-md bg-white p-6 dark:bg-bodyblack lg:w-4/5">
    <div class="flex w-full items-center justify-between">
      <h1 class="text-lg font-bold text-black dark:text-white mobile:text-xl">
        <span>
          <i class="fa-solid fa-file-certificate" />
        </span>
        &nbsp;&nbsp;Digital Certificate Details
      </h1>

      <button on:click class="h-7 w-7 rounded-full bg-red-500 text-sm font-bold text-white hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-400 active:text-white disabled:cursor-not-allowed dark:text-white dark:hover:hover:bg-red-600">
        <i class="fa-solid fa-xmark" />
      </button>
    </div>

    <div class="flex h-full w-full gap-3 overflow-auto">
      <div class="h-full w-[30%] overflow-y-auto overflow-x-scroll rounded-md border-r-2 border-[#f7f7f7] bg-[#f7f7f7] p-6 dark:border-[#222222] dark:bg-[#222222]">
        <div class="flex h-full flex-col justify-between gap-3">
          {#each certArray as cert, i (cert?.subject?.CN)}
            <CertTitle isFinal={i == certArray.length - 1} index={i} title={cert?.subject?.CN} bind:certActive bind:toggleSwitch />
          {/each}

          <div class="mt-auto">
            <div class="flex w-full items-center gap-3 rounded-md bg-white p-2 dark:bg-[#292a2f]">
              <div class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full {isCNMismatch ? 'bg-yellow-500' : 'bg-green-500'} text-white">
                <span>
                  <i class="fa-solid {isCNMismatch ? 'fa-triangle-exclamation' : 'fa-check'}" />
                </span>
              </div>
              <div class="space-y-1 text-sm text-black dark:text-white">
                <h1>
                  <span class="font-bold {isCNMismatch ? 'text-yellow-500' : 'text-green-500'}">VALID</span>
                  signature
                </h1>
                <h1 class="wordBreak text-xs">
                  Signed by
                  <span class="font-bold {isCNMismatch ? 'text-yellow-500' : 'text-green-500'}">{activeSigner}</span>
                </h1>
                <h1 class="wordBreak text-xs">
                  Issued by
                  <span class="font-bold {isCNMismatch ? 'text-yellow-500' : 'text-green-500'}">{certArray[certArray.length - 1]?.issuer?.CN || "-"}</span>
                </h1>
                {#if isCNMismatch}
                  <h1 class="wordBreak text-xs font-bold text-white">
                    <i class="fa-solid fa-circle-info" />
                    Signer Name and Common Name in Digital Signature Details Mismatch Detected
                  </h1>
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex h-full w-[70%] flex-col gap-3">
        <div class="flex w-full gap-3 text-base font-bold text-gray-d00">
          <div
            on:click={() => {
              active = "subject"
            }}
            class="w-full cursor-pointer rounded-md border-b-2 border-l-2 border-green-500 {active == 'subject' ? 'bg-green-500/25' : 'bg-transparent hover:bg-green-500/25'} py-3 px-2 text-green-500"
          >
            <span>
              <i class="fa-solid fa-xl fa-circle-user" />
            </span>
            &nbsp;&nbsp;Subject
          </div>
          <div
            on:click={() => {
              active = "issuer"
            }}
            class="w-full cursor-pointer rounded-md border-b-2 border-l-2 border-blue-500 {active == 'issuer' ? 'bg-blue-500/25' : 'bg-transparent hover:bg-blue-500/25'} py-3 px-2 text-blue-500"
          >
            <span>
              <i class="fa-solid fa-xl fa-building-columns" />
            </span>
            &nbsp;&nbsp;Issuer
          </div>
          <div
            on:click={() => {
              active = "details"
            }}
            class="w-full cursor-pointer rounded-md border-b-2 border-l-2 border-orange-500 {active == 'details' ? 'bg-orange-500/25' : 'bg-transparent hover:bg-orange-500/25'} py-3 px-2 text-orange-500"
          >
            <span>
              <i class="fa-solid fa-xl fa-file-certificate" />
            </span>
            &nbsp;&nbsp;Details
          </div>
          {#if Object.keys(data?.extension || {}).length}
            <div
              on:click={() => {
                active = "extension"
              }}
              class="w-full cursor-pointer rounded-md border-b-2 border-l-2 border-cyan-500 {active == 'extension' ? 'bg-cyan-500/25' : 'bg-transparent hover:bg-cyan-500/25'} py-3 px-2 text-cyan-500"
            >
              <span>
                <i class="fa-solid fa-xl fa-file-lines" />
              </span>
              &nbsp;&nbsp;Extensions
            </div>
          {/if}
        </div>

        <div class="flex h-full w-full flex-col overflow-hidden rounded-md bg-[#f7f7f7] dark:bg-[#222222]">
          <div class="flex flex-1 flex-col gap-3 overflow-auto p-6">
            {#if data && Object.keys(data).length && data[active]}
              {#each Object.entries(data[active]) as [innerKey, innerValue] (innerKey)}
                {#if innerValue}
                  <CertData key={innerKey} value={innerValue} />
                {/if}
              {/each}
            {/if}
          </div>

          <div class="flex-shrink-0 border-t border-gray-200 px-6 py-3 text-sm dark:border-[#333333]">
            Note: <span class="font-semibold text-blue-500">CLICK</span>
            the value to
            <span class="font-semibold text-blue-500">COPY</span>
            the text
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
  .subject {
    @apply border-green-500;
  }
  .subject-card {
    @apply bg-green-500/25 text-green-500;
  }
  .info {
    @apply border-blue-500;
  }
  .info-card {
    @apply bg-blue-500/25 text-blue-500;
  }
  .issuer {
    @apply border-orange-500;
  }
  .issuer-card {
    @apply bg-orange-500/25 text-orange-500;
  }
</style>
